import { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { useAPI } from 'src/services/api';

const buttonHoverStyle = {
  backgroundColor: '#ecebeb',
  color: 'black',
};

const MediaDownloadButton = ({
  attachmentUrl,
  originalFileName,
  index,
  customStyles = {},
  Icon = <></>,
}) => {
  const buttonStyle = {
    ...{
      borderColor: 'rgb(228, 228, 228)',
      height: '2rem',
      padding: '0.25rem 1rem',
      borderRadius: '1.5rem',
      backgroundColor: 'transparent',
      transition: 'background-color 0.3s',
      cursor: 'pointer',
    },
    ...customStyles,
  };

  const [downloading, setDownloading] = useState(false);
  const api = useAPI();
  const [buttonCurrentStyle, setButtonCurrentStyle] = useState(buttonStyle);

  const handleMouseEnter = () => {
    setButtonCurrentStyle({ ...buttonStyle, ...buttonHoverStyle });
  };

  const handleMouseLeave = () => {
    setButtonCurrentStyle(buttonStyle);
  };
  const handleDownload = async () => {
    setDownloading(true);
    try {
      const response = await api.get(`posts/download/${attachmentUrl}`, {
        responseType: 'blob', // Set response type to 'blob' to handle binary data
      }); // Create a hidden link and set the href to the received file

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', originalFileName); // Set the desired file name
      document.body.appendChild(link);
      link.click(); // Remove the link after download

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error occurred while downloading the file:', error);
    }
    setDownloading(false);
  };

  return (
    <button
      className="flex items-center border flex-wrap download-button"
      type="button"
      disabled={downloading}
      onClick={handleDownload}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onFocus={handleMouseEnter}
      onBlur={handleMouseLeave}
      style={buttonCurrentStyle}
      data-cy={`download-button-${index}`}
    >
      <>
        <Icon />

        {downloading ? (
          <>
            <Spinner animation="border" size="sm" style={{ marginLeft: '1rem' }} />
            <span style={{ marginLeft: '0.5rem' }}>Downloading...</span>
          </>
        ) : (
          <span data-cy="display-filename" style={{ marginLeft: '0.5rem', textAlign: 'center' }}>
            Download
          </span>
        )}
      </>
    </button>
  );
};

export default MediaDownloadButton;
